import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "fb-root" }, null, -1)
const _hoisted_2 = ["data-link"]
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.beliefnet.com/faiths/articles/~/media/images/components-v2/icons/icon-facebook-white.svg",
  alt: "Facebook"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.beliefnet.com/faiths/articles/~/media/images/components-v2/icons/icon-twitter-white.svg",
  alt: "Twitter"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.beliefnet.com/faiths/articles/~/media/images/components-v2/icons/icon-email-white.svg",
  alt: "Email"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

import { toRefs, inject, ref } from 'vue';
import { useLogger } from 'vue-logger-plugin';
import { UtilsService } from '../../services/utils.service';

// Incoming props

export default /*#__PURE__*/_defineComponent({
  __name: 'ShareV1',
  props: {
    pageUrl: String,
    dataLink: String,
    twitterUrl: String,
    facebookUrl: String
},
  setup(__props) {

const props = __props;



// get back prop values
const { pageUrl, dataLink, twitterUrl, facebookUrl } = toRefs(props);
const pageHref = ref('mailto:?subject=I wanted you to see this site&body=Check out this site ' + pageUrl?.value);

// use the logger
const logger = useLogger();
// utils services for including google captcha script
const utilsService: UtilsService | undefined = inject('UtilsService');
// load the script to handle the recaptcha
utilsService?.includeScript('https://platform.twitter.com/widgets.js', 'twitter-wjs', function () {
    logger.debug('Finished loaded twitter js');
});

utilsService?.includeScript(
    'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v7.0',
    'facebook-loadjs',
    function () {
        logger.debug('Finished loaded facebook js');
    },
    'xNkWMpmD',
    'anonymous'
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "social-sharing",
      "data-link": _unref(dataLink)
    }, [
      _createElementVNode("a", {
        target: "_blank",
        href: _unref(facebookUrl),
        class: "share-icon facebook"
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("a", {
        href: _unref(twitterUrl),
        target: "_blank",
        class: "share-icon twitter"
      }, _hoisted_8, 8, _hoisted_6),
      _createElementVNode("a", {
        href: pageHref.value,
        class: "share-icon email"
      }, _hoisted_11, 8, _hoisted_9)
    ], 8, _hoisted_2)
  ], 64))
}
}

})